import React from "react";
import a23logo from "../assets/a23_avatar_logo.png";
import close from "../assets/close.png";
import { connect } from "react-redux";
import { toggleModalAction, getBonusSummery } from '../redux/actions/userAction'
import Loading from "../models/Loading"
import navarrow from "../assets/back_btn.png";
import Tooltip from '../CustomTooltip.js';
import { Ring } from 'react-awesome-spinners'
import { Link } from "react-router-dom"
import { BONUSSUMMERY_STRINGS } from "../Strings";
import { WebToNativeMessage } from "../Common/Utils";
class SummaryBonus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      token: "",
      channel: "",
      _id: "",
      errors: {
        message: ""
      },
      bonusSummery: [],
      acelevelratios: [],
      userid: "",
      isBonusRatiosEqual: true,
      wagerRatio: 0,
      wagerReleaseRatio: 0,
      isuserhavePandingBonus: true
    };
  }

  getBonusSummaryDataInWallet = async (object) => {
    try {
      console.log("SB::getBonusSummaryDataInWallet called ", object);
      var data = JSON.parse(object);
      console.log("SB:::OBJECT DATA", data);
      console.log("SB:::TOKEN", data.token);
      console.log("SB:::CHANNEL", data.channel);
      console.log("SB:::ID", data._id);

      await this.props.getBonusSummery(data.token, data._id);

      const { bonusSummery } = this.props.userState;
      if (bonusSummery.error) {
        console.log("SB:::::DATA IN GETBONUS SUMMERY", bonusSummery.error);
        this.setState({
          errors: { message: bonusSummery.error.message },
          isLoading: false
        })
      } else {
        console.log("SB:::::DATA IN GETBONUS SUMMERY REPSONSE", bonusSummery);
        this.setState({
          bonusSummery: bonusSummery.bonusSummary,
          acelevelratios: bonusSummery.AceLevelCreditList,
          isLoading: false
        });
      }
      this.setState({ token: data.token, channel: data.channel, _id: data._id })
      window.sessionStorage["token"] = data.token;
      window.sessionStorage["channel"] = data.channel;
      window.sessionStorage["userid"] = data._id;
      //Apxor ScreenName Events  Start
      var screenValue = "";
      if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
        screenValue = "P_BonusSummary";
      } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
        screenValue = "FS_P_BonusSummary";
      } else {
        screenValue = "R_BonusSummary"
      }
      if (window.sessionStorage !== undefined) {
        WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
      }
      //Apxor ScreenName Events End

      this.checkforPendingBonus(this.state.bonusSummery);
    } catch (err) {
      console.log(err);
    }
  }

  dataToClient(object) {
    // console.log("SB::DATA TO CLIENT::", object)
    this.getBonusSummaryDataInWallet(object)
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  //Check if given Number is Integer or float
  checkforIntegerNumber = (num) => {
    if (typeof num == 'number' && !isNaN(num)) {
      if (Number.isInteger(num)) {
        return num;
      } else {
        return num.toFixed(2);
      }
    } else {
      return parseInt(num).toFixed(2);
    }
  }


  //Checking for pending Bonus is having or Not
  checkforPendingBonus = (arr) => {
    if (arr && arr !== undefined && arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        console.log("wager ratio:::", arr[i].pend);
        if (arr[i].runningPendingBonus > 0) {
          this.setState({ isuserhavePandingBonus: true })
          break;
        } else {
          this.setState({ isuserhavePandingBonus: false })
          //this.setState({isBonusRatiosEqual:false});
        }
      }
    } else {
      this.setState({ isuserhavePandingBonus: false })
    }
  }

  //Checking for Equal ratios
  allEqualCheck = (arr) => {
    console.log("AllEqual Check", arr, arr.length)
    if (arr && arr.length > 0) {
      let value = true
      for (let i = 0; i < arr.length - 1; i++) {
        // for (let k = i + 1; k < arr.length; k++) {
        if ((arr[i].wagerRatio != arr[i + 1].wagerRatio || arr[i].wagerReleaseRatio != arr[i + 1].wagerReleaseRatio)) {
          //console.log("gopi if",arr[i].wagerRatio+".....",arr[i+1].wagerRatio+"...."+"value of i",i+"....value of k",i+1) 
          value = false
          break;
          //return value
        } else {
          //console.log("gopi else",arr[i].wagerRatio+".....",arr[i+1].wagerRatio+"...."+"value of i",i+"....value of k",i+1) 
          value = true
        }
        //  }
      }
      // console.log("gopi value of i at later:",value)
      return value
    } else {
      return true
    }
  }



  async componentWillMount() {
    window.setCallback(this);
    // document.body.style.overflow = 'hidden';
    //for Dynamic Token
    // this.setState({token:window.sessionStorage["token"]})
    // this.setState({channel:window.sessionStorage["channel"]})
    // this.setState({userid:window.sessionStorage["userid"]})

    // console.log("SB:::::COMPONENT WILLMOUNT"+window.sessionStorage["token"] ,window.sessionStorage["userid"])

    // await this.props.getBonusSummery(window.sessionStorage["token"] ,window.sessionStorage["userid"]);
    // const { bonusSummery } = this.props.userState;
    // if (bonusSummery.error) {
    //   console.log("SB ::::COMPONENT WILL MOUNT", bonusSummery.error);
    //   await this.setState({
    //     errors: { message: bonusSummery.error.message },
    //     isLoading:false
    //   })
    // }else{
    //   console.log("SB::::COMPONENT WILLUNMOUNT", bonusSummery);
    //   await this.setState({
    //     bonusSummery:bonusSummery.bonusSummary,
    //       acelevelratios:bonusSummery.AceLevelCreditList,
    //     isLoading:false
    //   });
    //  this.checkforPendingBonus(this.state.bonusSummery);
    // }     
  }

  async componentDidMount() {
    //document.body.style.overflow = 'hidden';
    //this.setState({token:window.sessionStorage["token"]})
    //this.setState({channel:window.sessionStorage["channel"]})


    if (window.sessionStorage["token"] !== undefined && window.sessionStorage["token"] !== "" &&
      window.sessionStorage["token"] !== null) {
      console.log("SB:::COMPONENT DID MOUNT:::", window.sessionStorage["token"], window.sessionStorage["userid"])
      if (this.state.token === "" && window.sessionStorage["userid"] !== "") {
        await this.props.getBonusSummery(window.sessionStorage["token"], window.sessionStorage["userid"]);
        const { bonusSummery } = this.props.userState;
        if (bonusSummery.error) {
          console.log("SB:::COMPONENT DID MOUNT:::", bonusSummery.error);
          this.setState({
            errors: { message: bonusSummery.error.message },
            isLoading: false
          })
        } else {
          console.log("SB:::COMPONENT DID MOUNT:::RESPOSNE", bonusSummery);
          this.setState({
            bonusSummery: bonusSummery.bonusSummary,
            acelevelratios: bonusSummery.AceLevelCreditList,
            isLoading: false
          });
          //Apxor ScreenName Events  Start
          var screenValue = "";
          if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
            screenValue = "P_BonusSummary";
          } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
            screenValue = "FS_P_BonusSummary";
          } else {
            screenValue = "R_BonusSummary"
          }
          if (window.sessionStorage !== undefined) {
            WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
          }
          //Apxor ScreenName Events End
          this.checkforPendingBonus(this.state.bonusSummery);
        }
      }
    }
  }

  handleBackBtnClick = (msg) => {
    console.log("back button summery bonus:::", msg, this.props.location.from, window.sessionStorage["isfrom"]);
    if (window.sessionStorage["isfrom"] === "wallet") {
      this.props.history.push("/walletinfo/")
      sessionStorage.setItem("fromScreen", "wallet")
    } else {
      WebToNativeMessage(msg)
    }
  }

  handleOutSideClick = () => {
    const handleOutSideClick = new Event('handleOutSideClick');
    dispatchEvent(handleOutSideClick);
  }

  render() {

    console.log("SB::::renderMethod:::PendingBonus::", this.state.isuserhavePandingBonus, this.props.userState.bonusSummery.bonusSummary, this.state.bonusSummery);

    return (
      <div onClick={this.handleOutSideClick}>

        {/* <nav
            className=" ph2 pv2 tr fixed top-0 left-0 right-0 shadow-4 z-999 "
            style={{ backgroundColor: "#eabf69" ,color:"#032146" }}
          >
            <div className="w-100  db center ">
              <div className="flex justify-start items-center" >
                <img fill="#ffffff"
                  className="w1"
                  src={navarrow}
                  alt="no available"
                  style={{width:"25px"}} onClick={()=>this.handleBackBtnClick({type:"closeClient"})}/>
                <p className="f4-l f4 mv0 text-medium tc ml2">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY}</p>
              </div>
            </div>

          </nav> */}
        <nav className='navbar'>
          <div className="nav-container" >
            {/* <Link to="/walletinfo/"> */}
            <img
              className='backBtn'
              src={navarrow}
              style={{ width: "40px" }}
              onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
            />
            {/* </Link> */}
            <p className="nav-text" style={{ textAlign: 'center' }}>Bonus Summary</p>
            <div></div>
          </div>
        </nav>


        <div className="innerSection">
          <div className=" f6 w-100 db center ph2  bg-grey pb6 relative" style={{ marginTop: "1rem" }}>

            {this.state.isLoading ? <div className="center tc"><Ring size={64} color='#008000' sizeUnit='px' /></div> : (this.state.bonusSummery || this.state.acelevelratios) ? (
              <div className="w-100 db">

                <div className="flex items-center ph2">

                  <span className="pr2" style={{ fontSize: "0.8rem", color: "#032146" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT1}</span>

                  <div className="white br2 pv2" style={{ backgroundColor: "#E2B300" }} >
                    {/* <p className="mv2 mh2" style={{fontSize:"0.95rem"}}>Check Bonus Offers</p> */}
                    <Link className="  mv2 mh2 no-underline input-reset outline-0" style={{ fontSize: "0.8rem", color: "#032146", textDecoration: "none" }} to={{ pathname: "/bonusoffers/" }}>Check Bonus Offers</Link>
                  </div>
                </div>

                <div className="w-100 mt2 pl4">
                  <ul className="pv0 ph0" style={{ fontSize: "0.8rem", color: "#032146" }}>
                    <li>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT2}</li>
                    <li className="mt1">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT3}</li>
                    <li className="mt1">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT4}</li>
                  </ul>
                </div>

                {this.state.isuserhavePandingBonus ? (<div></div>) : (<p style={{ fontSize: "0.8rem" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT5}</p>)}

                {this.state.bonusSummery && this.state.bonusSummery.map((x, i) => {
                  const t = new Date(x.createdAt)
                  const expiredAt = new Date(x.expiryAt)
                  //const isBonusRatiosEqual=false;
                  //if(x.wagerReleaseRatio){
                  const isBonusRatiosEqual = this.allEqualCheck(x.wagerReleaseRatio)
                  //const isBonusRatiosEqual = false
                  //}else{
                  // isBonusRatiosEqual = true;
                  //}

                  console.log("bonus Summery render called isBonusratiosEqual", isBonusRatiosEqual, x.bonusCode)
                  return <div className="w-100 pv2  fw3" key={i} >
                    {isBonusRatiosEqual ? (<div>




                      <table className=" w-100  center ba br2 bt0 bg-white   " cellspacing="0" style={{ borderColor: "#C3CBD3", paddingLeft: "0.5px", paddingRight: "0.5px", paddingTop: "0.5px" }}>
                        <tr className="tc   ">
                          <th className="pa1 pv1  bl-0 bb-0 bt- br2  br--left fw6" style={{ backgroundColor: "#eabf69", borderColor: "#C3CBD3", color: "#032416", fontSize: "0.8em" }}>{x.bonusCode}</th>
                          {x.expiryAt == "NA" ? (<th className="pa1 pv2 bb-0 br2 bl-2  br--right fw6" style={{ backgroundColor: "#eabf69", borderColor: "#C3CBD3", color: "#032416", fontSize: "0.8em" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_EXPIRY_DATE}{x.expiryAt}</th>) : (<th className="pa1 pv2 bb-0 br2 bl-2  br--right fw6" style={{ backgroundColor: "#eabf69", borderColor: "#C3CBD3", color: "#032416", fontSize: "0.8em" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_EXPIRY_DATE}{`${expiredAt.getDate()}-${expiredAt.toLocaleString("en-GB", { month: "2-digit" })}-${expiredAt.getFullYear()}`}  at  {`${expiredAt.getHours()}:${(expiredAt.getMinutes() < 10 ? '0' : '') + expiredAt.getMinutes()}`}</th>)}
                          {/* <th className="pa1 pv2 bb-0 br2 bl-2 f6-l f7 br--right text-medium" style={{backgroundColor:"#eabf69",borderColor:"#C3CBD3",color:"#032416"}}>Expiry Date : {`${expiredAt.getDate()}-${expiredAt.toLocaleString("en-GB", { month: "2-digit" })}-${expiredAt.getFullYear()}`} &nbsp; {`${expiredAt.getHours()}:${(expiredAt.getMinutes()<10?'0':'') + expiredAt.getMinutes()}`}</th> */}
                        </tr>
                        <tr></tr>
                        <tbody >
                          <tr className="tc  bg-white ">
                            {(x.wagerReleaseRatio && x.wagerReleaseRatio.length > 0) ? (<td className="pa1 ba tl pl2 pv2   text-medium   " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_WAGER_RATIO}&nbsp;&nbsp; {x.wagerReleaseRatio[0].wagerRatio}:{x.wagerReleaseRatio[0].wagerReleaseRatio} </td>) : (<td className="pa1 ba tl pl2 pv2  text-medium     " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_WAGER_RATIO}&nbsp;&nbsp;NA </td>)}
                            <td className="pa1 ba tl ml2 pv2  text-medium  " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_ISSUE_DATE} &nbsp;&nbsp; {`${t.getDate()}-${t.toLocaleString("en-GB", { month: "2-digit" })}-${t.getFullYear()}`} &nbsp; at &nbsp; {`${t.getHours()}:${(t.getMinutes() < 10 ? '0' : '') + t.getMinutes()}`}</td>

                          </tr>

                          <tr className="tc " style={{ backgroundColor: "#F4F4F4" }}>
                            <td className="pa1 ba tl pl2 pv2  text-medium " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_ISSUE_AMOUNT}&nbsp;&nbsp;{this.checkforIntegerNumber(x.totalBonusValue)}</td>
                            <td className="pa1 ba tl ml2 pv2  text-medium " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_INSTANT_ISSUE_AMOUNT} &nbsp;&nbsp;{this.checkforIntegerNumber(x.instantBonusComponent)}</td>

                          </tr>
                          <tr className="tc bg-white">
                            <td className="pa1 ba tl pl2 pv2  text-medium " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMERY_CREDITED_AMOUNT}&nbsp;&nbsp;{this.checkforIntegerNumber(x.creditedAmount)}</td>
                            <td className="pa1 ba tl ml2 pv2  text-medium " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.8em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMERY_PENDING_AMOUNT}&nbsp;&nbsp;{this.checkforIntegerNumber(x.runningPendingBonus)}</td>

                          </tr>



                        </tbody>
                      </table></div>) : (<div> <table className=" w-100   center ba br2 bt0 bg-white  " cellspacing="0" style={{ borderColor: "#C3CBD3", paddingLeft: "0.5px", paddingRight: "0.5px", paddingTop: "0.5px" }}>
                        <tr className="tc  pa1 ">
                          <th className="pa1  bb-0 bt-0 br2  pv2 br-0 fe6 br--left" style={{ backgroundColor: "#DEDEDE", borderColor: "#C3CBD3", color: "#032146", fontSize: "0.8em" }}>{x.bonusCode}</th>
                          {x.expiryAt == "NA" ? (<th className="pa1 bb-0 br2 bl-2   pv2 br-0 fw6 br--right" style={{ backgroundColor: "#DEDEDE", borderColor: "#C3CBD3", color: "#032416", fontSize: "0.75em" }}>Expiry Date :{x.expiryAt}</th>) : (<th className="pa1 bb-0 br2 bl-2  pv2 br-0 fw6 br--right" style={{ backgroundColor: "#DEDEDE", borderColor: "#C3CBD3", color: "#032416", fontSize: "0.8em" }}>Expiry Date :{`${expiredAt.getDate()}-${expiredAt.toLocaleString("en-GB", { month: "2-digit" })}-${expiredAt.getFullYear()}`}  at  {`${expiredAt.getHours()}:${(expiredAt.getMinutes() < 10 ? '0' : '') + expiredAt.getMinutes()}`}</th>)}
                        </tr>
                        <tr></tr>
                        <tbody >
                          <tr className="tc  bg-white">
                            <td className=" ba tc center  pv2 text-medium" style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.7em" }}><div className="flex justify-between"><span>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_WAGER_RATIO}{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_GAME_WISE}</span><span>
                              <Tooltip
                                tooltipBox="bonus-tooltip-box"
                                tooltipArrow="tooltip-arrow"
                                from=""
                                text={

                                  x.wagerReleaseRatio.map((listValue, index) => {
                                    return (
                                      <div className="center tc flex " key={index}>
                                        <span className="tc text-medium mt1" style={{ color: "#032416", fontSize: "0.75em" }}>{listValue.gameType.charAt(0).toUpperCase() + listValue.gameType.slice(1)}</span>
                                        <span className="tc text-medium mt1" style={{ color: "#032416", fontSize: "0.75em" }}>-</span>
                                        <span className="tc pl2 text-medium mt1" style={{ color: "#032416", fontSize: "0.75em" }}>&nbsp;{listValue.wagerRatio}:{listValue.wagerReleaseRatio}</span>
                                      </div>
                                    );
                                  })}
                              >
                                <div className="f10 flex justify-center items-center br-100 " style={{ width: "1rem", height: "1rem", padding: "0.5rem", backgroundColor: "#58b6c6", color: "#F8F8F8" }}>i

                                </div>
                              </Tooltip></span></div>
                            </td>
                            <td className="pa1 ba tl ml2 pv2  text-medium" style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.7em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_ISSUE_DATE} &nbsp;{`${t.getDate()}-${t.toLocaleString("en-GB", { month: "2-digit" })}-${t.getFullYear()}`}  at  {`${t.getHours()}:${(t.getMinutes() < 10 ? '0' : '') + t.getMinutes()}`}</td>

                          </tr>

                          <tr className="tc" style={{ backgroundColor: "#F4F4F4" }}>
                            <td className="pa1 ba tl pl2 pv2  text-medium  " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.7em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_ISSUE_AMOUNT}&nbsp;&nbsp;{this.checkforIntegerNumber(x.totalBonusValue)}</td>
                            <td className="pa1 ba tl ml2 pv2  text-medium " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.7em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_INSTANT_ISSUE_AMOUNT}&nbsp;&nbsp;{this.checkforIntegerNumber(x.instantBonusComponent)}</td>

                          </tr>
                          <tr className="bg-white ">
                            <td className="pa1 ba tl pl2 pv2  text-medium " style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.7em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMERY_CREDITED_AMOUNT}&nbsp;&nbsp;{this.checkforIntegerNumber(x.creditedAmount)}</td>
                            <td className="pa1 ba tl ml2 pv2  text-medium" style={{ borderColor: "#E6E6E6", color: "#032146", fontSize: "0.7em" }}>&nbsp;{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMERY_PENDING_AMOUNT}{this.checkforIntegerNumber(x.runningPendingBonus)}</td>

                          </tr>



                        </tbody>
                      </table></div>)}

                  </div>
                })}

                <div className="ph2 mt2 mb2 center">

                  <div className=" center mr1 mb3" style={{ color: "#032146", fontSize: "0.8rem" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT6}</div>
                  <span className="fw6 mt2" style={{ fontSize: "0.8rem" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_MORE_INFORMATION}</span>

                  <div className="w-100 mt2 ph2 pl2">
                    <ul className="pv0 ph0" style={{ fontSize: "0.8rem", color: "#032146" }}>
                      <li>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT7}</li>
                      {/* <li className="mt1">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT8}</li> */}
                    </ul>
                  </div>

                  <div className="mt2">


                    <table className="f6 w-100 dt dt--fixed  mr1 ml1 center ba br2 bt0 bg-white  " cellspacing="0" style={{ borderColor: "#C3CBD3" }}>
                      <tr className="tc  pa1 ">
                        <th className="pa1  bb-0 bt-0 br2  br-0 text-bold br--left" style={{ backgroundColor: "#eabf69", borderColor: "#C3CBD3", color: "#032416" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_LEVEL}</th>

                        <th className="pa1 bb-0 br2 bl-2 text-bold br--right" style={{ backgroundColor: "#eabf69", borderColor: "#C3CBD3", color: "#032416" }}>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_CREDIT}</th>
                      </tr>
                      <tr></tr>
                      <tbody className="lh-copy ">

                        {this.state.acelevelratios.map((listValue, index) => {
                          return (
                            <tr className="tc  striped--near-white" key={index}>
                              <td className="pa1 ba tc pl2 " style={{ borderColor: "#E6E6E6" }}>{listValue.acelevel.charAt(0).toUpperCase() + listValue.acelevel.slice(1)}</td>
                              <td className="pa1 ba tc pr2 " style={{ borderColor: "#E6E6E6" }}>{listValue.credit}</td>
                            </tr>
                          );
                        })}

                      </tbody>
                    </table>
                  </div>


                  <div className="w-100 mt2  ph2  pl2">
                    <ul className="pv0 ph0" style={{ fontSize: "0.8rem", color: "#032146" }}>
                      <li>{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT8}</li>
                      <li className="mt1">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT9}</li>
                      <li className="mt1">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY_TEXT10}</li>

                    </ul>
                  </div>
                </div>


              </div>







            ) : (<div><p className="f5 tc center"></p></div>)}



          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = state => ({
  userState: state.userState
});

export default connect(
  mapStateToProps,
  { toggleModalAction, getBonusSummery }
)(SummaryBonus);
